<!--
component: YearButtonPad
author: Ken Nakamura
description: 年度ボタンパネル
-->
<template>
  <section class="year-button-pad">
    <v-container fluid>
      <v-row class="px-4">
        <v-col v-for="(year,index) in years" :key="index" cols=3>
          <v-btn color="#c6e9ef" width="95%" x-large
            @click="selectNendo(year)"
            :disabled="year.year<wardNendo"
            class="text-h5" style="margin:-8px;">
            {{ year.capt }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
import constants from '../common/constants'
import { dbglog } from '../common/utils.js'

export default {
  data: () => {
    return {
      years: [
        {year: 2019, capt: 'R01'},
      ],
    }
  },
  props: {
    era: {
      type: Number,
      default: 5,
    },
    wareki: {
      type: Boolean,
      default: true,
    },
  },
  mounted () {
    this.initNendoButton(this.era);
  },
  computed: {
    ward () { return this.$store.state.ward; },
    wardNendo () {
      return (this.ward ? this.ward.nendo : 0 );
    }
  },
  methods: {
    /**
     * 年度ボタンの初期化
     * @param {Number} era 対象となる元号コード（3:昭和、4:平成、5:令和）
     */
    initNendoButton(era) {
      this.years = [];
      const def = constants.warekiDef[era];
      let startNendo = '';
      dbglog(def, 0);
      // 狭あい道路の際、平成7年からしか実測図のデータが無い為それ以前は表示させない
      if(this.$store.state.mode == 7 && era == 4){
        startNendo = def.startNendo + 6;
      }else {
        startNendo = def.startNendo;
      }
      for (let i = startNendo; i <= def.lastNendo; i++) {
        this.years.push({
          year: def.firstYear + i - 1,
          capt: (this.wareki ? def.shortEra + i : def.firstYear + i - 1)
        })
      }
    },
    /**
     * 年度ボタンが押された時の処理
     * @param {Number} n 選択された年（西暦）
     */
    selectYear (n) {
        this.$emit('selectYear', n);
    },
    /**
     * 年度ボタンが押された時の処理
     * @param {String} n 選択された年度
     */
    selectNendo (n) {
        this.$emit('selectNendo', n);
    },
  }
}
</script>

<style lang="scss" scoped>
.year-button-pad {
    background-color: #b6d9df;
    user-select: none;
    width: 100%;
    height: 100%;
    padding: 8px 8px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2),
    0 25px 50px 0 rgba(0, 0, 0, 0.1);
}

</style>